import _ from 'underscore';
import { DataSourceState } from '@bingads-webui-react/image-picker'; // eslint-disable-line
import {
  hasMoreImagesToFetch,
} from '@bingads-webui-campaign/media-repository';

class ImageSuggestionsDataSource {
  constructor({
    loadMoreByPageNumber,
  }) {
    this.loadMoreByPageNumber = loadMoreByPageNumber;

    this.currentData = [];
    this.currentPageNumber = 1;
    this.hasMore = false;
  }

  subscribe(callback) {
    this.callback = callback;
  }

  unsubscribe() {
    this.callback = null;
  }

  executeCallBackIfExist(status) {
    if (this.callback) {
      this.callback(status);
    }
  }

  loadMore() {
    this.executeCallBackIfExist(DataSourceState.Loading);
    this.currentPageNumber += 1;

    return this.loadMoreByPageNumber(this.currentPageNumber)
      .then((data) => {
        this.hasMore = hasMoreImagesToFetch(data);

        const moreData = data.Images.map(({ ImageUrl, ThumbnailUrl }) => ({
          src: ThumbnailUrl,
          fullSrc: ImageUrl,
          id: parseInt(_.uniqueId(), 10),
        }));

        this.currentData = this.currentData.concat(moreData);
      })
      .catch((e) => { throw e; })
      .finally(() => {
        this.executeCallBackIfExist(DataSourceState.Done);
      });
  }

  reload(data, hasMore) {
    this.currentPageNumber = 1;
    this.currentData = data;
    this.hasMore = hasMore;
    this.executeCallBackIfExist(DataSourceState.Done);
  }

  getData() {
    return { hasMore: this.hasMore, data: this.currentData };
  }
}

const initializeImageSuggestionsDataSource = ({
  loadMoreByPageNumber,
}) => (new ImageSuggestionsDataSource({ loadMoreByPageNumber }));

export { initializeImageSuggestionsDataSource };
